<div class="page-content page-fill">
  <div class="grid-fill">
    <dx-data-grid
      #accountsGrid
      [dataSource]="accounts"
      keyExpr="id"
      [showBorders]="true"
      [focusedRowEnabled]="false"
      [showColumnLines]="false"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onRowDblClick)="rowDoubleClick($event)"
      (onRowPrepared)="rowPrepare($event)"
      >
      <dxi-column width="30" cellTemplate="faTemplate"> </dxi-column>
      <dxi-column dataField="active" [width]="85"></dxi-column>
      <dxi-column dataField="name" [width]="500" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      @if (appInfo.graafschap) {
        <dxi-column dataField="quickBooksAccount" [width]="200" caption="QB Acct"></dxi-column>
      }
      @if (appInfo.graafschap) {
        <dxi-column dataField="classisAccount" [width]="200" caption="Classis Acct"></dxi-column>
      }
      <dxi-column dataField="website" [width]="200"></dxi-column>
      <dxi-column dataField="notes" [width]="200"></dxi-column>
      <dxi-column dataField="displayOrder" [width]="200" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="alwaysInclude" [width]="200"></dxi-column>

      <div *dxTemplate="let item of 'faTemplate'" class="d-flex">
        @if (item.data.hasAttachment) {
          <i class="fa fa-paperclip" title="Attachment"></i>
        }
      </div>

      <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="accounts-list-grid"></dxo-state-storing>
      <dxo-selection [mode]="'single'" showCheckBoxesMode="true"></dxo-selection>

      <div *dxTemplate="let data of 'toolbarButtons'">
        @if (canAdd) {
          <button class="btn btn-success" (click)="open(true, null)">Add</button>
        }
        <button class="btn btn-primary ms-2" (click)="open(true, null)">Open</button>
      </div>
    </dx-data-grid>
  </div>
</div>
